// Property type factories used to build appearance editors
import {
  StrokeType,
  FillType,
  FontType,
  FibLevelsType,
} from "../PropertyTypes";

// Fibonacci category - includes all Fibonacci-based drawing tools
const fibonacciRegistry = {
  displayName: "Fibonacci",
  interactives: {
    fibRetracement: {
      displayName: "Retração Fibonacci",
      key: "fibRetracement",
      icon: "Fib_Retracement",
      propName: "retracements",
      component: "FibonacciRetracement",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#FF9800",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
        FontType({
          name: "font",
          displayName: "Fonte",
          defaultValue: {
            fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
            color: "#FF9800",
            fontSize: 11,
          },
        }),
        FibLevelsType({
          name: "levels",
          displayName: "Niveis",
          defaultValue: [
            { level: 100, display: true },
            { level: 61.8, display: true },
            { level: 50, display: true },
            { level: 38.2, display: true },
            { level: 23.6, display: true },
            { level: 0, display: true },
          ],
        }),
      ],
    },
    fibProjection: {
      displayName: "Projeção Fibonacci",
      key: "fibProjection",
      icon: "Fib_Projection",
      propName: "projections",
      component: "FibonacciProjection",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#FF9800",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
        FontType({
          name: "font",
          displayName: "Fonte",
          defaultValue: {
            fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
            color: "#FF9800",
            fontSize: 11,
          },
        }),
        FillType({
          name: "fill",
          displayName: "Preenchimento",
          defaultValue: { color: "#FF9800", opacity: 0.1 },
        }),
        FibLevelsType({
          name: "levels",
          displayName: "Niveis",
          defaultValue: [
            { level: 423.6, display: true },
            { level: 261.8, display: true },
            { level: 161.8, display: true },
            { level: 127.2, display: true },
            { level: 100, display: true },
            { level: 61.8, display: true },
            { level: 0, display: true },
          ],
        }),
      ],
    },
    fibExtension: {
      displayName: "Extensão Fibonacci",
      key: "fibExtension",
      icon: "Fib_Extension",
      propName: "extensions",
      component: "FibonacciExtension",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#FF9800",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
        FontType({
          name: "font",
          displayName: "Fonte",
          defaultValue: {
            fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
            color: "#FF9800",
            fontSize: 11,
          },
        }),
        FibLevelsType({
          name: "levels",
          displayName: "Niveis",
          defaultValue: [
            { level: 423.6, display: true },
            { level: 261.8, display: true },
            { level: 161.8, display: true },
            { level: 127.2, display: true },
            { level: 100, display: true },
            { level: 61.8, display: true },
            { level: 0, display: true },
          ],
        }),
      ],
    },
    fibArcs: {
      displayName: "Arcos Fibonacci",
      key: "fibArcs",
      icon: "Fib_Arc",
      propName: "arcs",
      component: "FibonacciArcs",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#00BFFF",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
        FontType({
          name: "font",
          displayName: "Fonte",
          defaultValue: {
            fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
            color: "#00BFFF",
            fontSize: 11,
          },
        }),
        FillType({
          name: "fill",
          displayName: "Preenchimento",
          defaultValue: { color: "#00BFFF", opacity: 0.05 },
        }),
        FibLevelsType({
          name: "levels",
          displayName: "Niveis",
          defaultValue: [
            { level: 100, display: true },
            { level: 61.8, display: true },
            { level: 50, display: true },
            { level: 38.2, display: true },
          ],
        }),
      ],
      // Internal properties for rendering (not exposed in UI)
      appearance: {
        r: 6, // drag handle radius
      },
    },
    fibFan: {
      displayName: "Leque Fibonacci",
      key: "fibFan",
      icon: "Fib_Fan",
      propName: "fans",
      component: "FibonacciFan",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#FF9800",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
        FontType({
          name: "font",
          displayName: "Fonte",
          defaultValue: {
            fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
            color: "#FF9800",
            fontSize: 11,
          },
        }),
        FibLevelsType({
          name: "levels",
          displayName: "Niveis",
          defaultValue: [
            { level: 100, display: true },
            { level: 61.8, display: true },
            { level: 50, display: true },
            { level: 38.2, display: true },
            { level: 0, display: true },
          ],
        }),
      ],
    },
    fibTimeZones: {
      displayName: "Zonas Tempo Fibonacci",
      key: "fibTimeZones",
      icon: "Fib_TimeZones",
      propName: "timeZones",
      component: "FibonacciTimeZones",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#FF9800",
            dash: "Solid",
            width: 1,
            opacity: 0.5,
          },
        }),
        FontType({
          name: "font",
          displayName: "Fonte",
          defaultValue: {
            fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
            color: "#FF9800",
            fontSize: 11,
          },
        }),
        FillType({
          name: "fill",
          displayName: "Preenchimento",
          defaultValue: { color: "#FF9800", opacity: 0.05 },
        }),
      ],
    },
  },
};

export default fibonacciRegistry;
